module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>Notifications - Dashboard</h1>\r\n        </div>\r\n    </div>\r\n    <ol class=\"breadcrumb\">\r\n        <li class=\"active\">Notifications</li>\r\n    </ol>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col col-sm-12\">\r\n        <h2>")
    ; __append(escapeFn( notificationCount ))
    ; __append("</h2>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n        <table id=\"propNotifyTable\"></table>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-6\"><h2>Information</h2></div>\r\n    <div class=\"col-md-6\"><h2>Notifications Help</h2></div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n        <p>Notifications are messages sent to you because somebody wants you to\r\n        view an app. Each notification has an attention level that indicates the urgency for your action.</p>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <a href=\"")
    ; __append(escapeFn(constants.HELP_NOTIFICATIONS_URL ))
    ; __append("\" target=\"_blank\">\r\n            Notifications Dashboard\r\n        </a>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}